'use strict';

import {recoveryModel} from "@js/models/recoverymodel";

export class ProjectRecoveryCtrl
{
	dataModel = {};
	showRequire = false;
	classif;
	cfg;
	require = {
		irregularities_ids: true,
		type: true,
		amount: true,
		expiry_date_cet: true,
		justification: true,
	};
	
	constructor($scope, $filter, $timeout, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$timeout = $timeout;
		this.$mdDialog = $mdDialog;
		this.notify = notify;
		this.jsDataService = jsDataService;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.cfg = this.jsDataService.get('cfgRecovery', {});
		this.recoveryAttachments = this.jsDataService.get('recoveryAttachments', []);
		this.setDataModel(this.jsDataService.get('recovery', {}));
		this.$timeout(()=>{
			this.changedLinkedToBreach();
		}, 50);
	}
	
	setDataModel(data){
		this.dataModel = new recoveryModel(data, this.$filter, this.jsDataService);
	}
	
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
	
	modelValue(name){
		if(typeof(this.dataModel) !== 'undefined'){
			return this.dataModel.getValue(name);
		}
		return '';
	}
	
	fldRequired(name){
		return (typeof(this.require[name]) !== 'undefined' && true === this.require[name]);
	}
	
	changedLinkedToBreach(){
		this.require.irregularities_ids = (this.dataModel.linked_to_breach == 1);
	}
	
	autosavePostFields(){
		let postData = this.dataModel.getData();
		if(this.dataModel.decision_date_cet instanceof Date){
			postData.decision_date = this.$filter('date')(this.dataModel.decision_date_cet, 'yyyy-MM-dd');
		}
		else{
			postData.decision_date = 0;
		}
		if(this.dataModel.expiry_date_cet instanceof Date){
			postData.expiry_date = this.$filter('date')(this.dataModel.expiry_date_cet, 'yyyy-MM-dd');
		}
		else{
			postData.expiry_date = 0;
		}
		if(this.dataModel.payment_date_cet instanceof Date){
			postData.payment_date = this.$filter('date')(this.dataModel.payment_date_cet, 'yyyy-MM-dd');
		}
		else{
			postData.payment_date = 0;
		}
		return postData;
	}
	
	complete(ev, form){
		this.showRequire = true;
		this.$timeout(()=>{
			if(form.$invalid){
				if(this.dataModel.linked_to_breach == 1 && this.classif.irregularities.length == 0){
					this.notify(this.$filter('tr')('err_check_recovery_no_irregularities'), true);
				} else {
					this.notify(this.$filter('tr')('err_check_required_fields'), true);
				}
			}
			else{
				const confirmTexts = this.jsDataService.get('recoveryConfirmTexts');
				const confirm = this.$mdDialog.confirm()
					.title(confirmTexts.title)
					.htmlContent(confirmTexts.content)
					.ariaLabel(confirmTexts.title)
					.targetEvent(ev)
					.ok(confirmTexts.ok)
					.cancel(confirmTexts.cancel);
				this.$mdDialog.show(confirm).then(() => {
					this.$scope.basicHttpConfigProcess({
						url: this.jsDataService.get('cfgConfirmUrl'),
						method: 'GET',
						params: {}
					}).then((results) => {
						if(results.data.success){

						}
					});
				}, () => {});
			}
		});
	}
	
	dialogCtrl($scope, $mdDialog, jsDataService, postElements, cfg){
		$scope.classif = jsDataService.get('cfgClassif', {});
		$scope.cfg = cfg;
		$scope.postElements = postElements;
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function() {
			$mdDialog.hide($scope.postElements);
		};
	}
	
	changeStatus(ev){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "jsDataService", "postElements", "cfg", this.dialogCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'projects/ng_recovery_status.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: true,
			fullscreen: true,
			locals: {
				postElements: {
					'status': this.dataModel.status,
					'comment': this.dataModel.comment,
				},
				cfg: {}
			}
		}).then((results) => {
			if(this.cfg.statusUrl){
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.statusUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	reject(ev){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "jsDataService", "postElements", "cfg", this.dialogCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'esfasi/ng_comment.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: true,
			fullscreen: true,
			locals: {
				postElements: {
					'status': this.dataModel.status,
					'comment': this.dataModel.comment,
				},
				cfg: {
					mandatory: this.cfg?.rejectMandatory,
					dialogTitle: this.cfg?.rejectTitle,
					explain: this.cfg?.rejectExplain,
					submitButton: this.cfg?.rejectButton,
				}
			}
		}).then((results) => {
			if(this.cfg.statusUrl){
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.rejectUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	confirm(ev){
		this.$timeout(()=>{
			const confirmTexts = this.jsDataService.get('recoveryCompleteTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.confirmUrl,
					method: 'GET',
					params: {}
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		});
	}
	
	expiry(ev){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "jsDataService", "postElements", "cfg", this.dialogCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'projects/ng_recovery_expiry.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: true,
			fullscreen: true,
			locals: {
				postElements: {
					'expiry_date_cet': this.dataModel.expiry_date_cet,
					'expiry_date': this.dataModel.expiry_date,
				},
				cfg: {}
			}
		}).then((results) => {
			if(this.cfg.expireUrl){
				if(results.expiry_date_cet instanceof Date){
					results.expiry_date = this.$filter('date')(results.expiry_date_cet, 'yyyy-MM-dd');
				}
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.expireUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	lateInterest(ev){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "jsDataService", "postElements", "cfg", this.dialogCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'projects/ng_recovery_lateinterest.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: true,
			fullscreen: true,
			locals: {
				postElements: {
					'late_interest_amount': this.dataModel.late_interest_amount,
				},
				cfg: {}
			}
		}).then((results) => {
			if(this.cfg.lateinterestUrl){
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.lateinterestUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	payment(ev){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "$filter", 'notify', 'postElements', 'cfg', this.paymentCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'projects/ng_recovery_payment.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				postElements: {
					attachments: [],
					payment_date_cet: this.dataModel.payment_date_cet,
					payment_date: this.dataModel.payment_date,
					comment: this.dataModel.comment,
				},
				cfg: this.cfg
			}
		}).then((results) => {
			if(this.cfg?.paymentUrl){
				if(results.payment_date_cet instanceof Date){
					results.payment_date = this.$filter('date')(results.payment_date_cet, 'yyyy-MM-dd');
				}
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.paymentUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	approve(ev){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "$filter", 'notify', 'postElements', 'cfg', this.paymentCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'projects/ng_recovery_approve.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				postElements: {
					attachments: [],
					decision_date_cet: this.dataModel.decision_date_cet,
					decision_date: this.dataModel.decision_date,
					comment: this.dataModel.comment,
				},
				cfg: this.cfg
			}
		}).then((results) => {
			if(this.cfg?.approveUrl){
				if(results.decision_date_cet instanceof Date){
					results.decision_date = this.$filter('date')(results.decision_date_cet, 'yyyy-MM-dd');
				}
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.approveUrl,
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){

					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	paymentCtrl($scope,$mdDialog, $filter, notify, postElements, cfg){
		$scope.cfg = cfg;
		$scope.dragClass = '';
		$scope.attfile = {
			file: {}
		};
		
		$scope.postElements = postElements;
		
		$scope.fileUploaded = function($file, $message, $flow){
			if($file.response.success){
				$scope.attfile.file.file_id = $file.response.fileId;
				$scope.attfile.file.done = true;
				$scope.saveAttachment($scope.attfile);
			}
		};

		$scope.filesAdded = function($files){
			return true;
		};

		$scope.fileAdded = function($file){
			const ext = $file.getExtension();
			if(typeof($scope.cfg.fileFilter[ext]) === 'undefined' || !$scope.cfg.fileFilter[ext]){
				notify($filter('tr')('file_wrong_format'), true);
				return false;
			}
			if(typeof($scope.cfg.maxFileSize) !== 'undefined' && $file.size > $scope.cfg.maxFileSize){
				notify($file.name + ' - ' + $filter('tr')('file_size_error'), true);
				return false;
			}
			if(!$scope.activeUpload()){
				return false;
			}
			$scope.addFlowFile($file);
			return true;
		};

		$scope.fileSubmited = function(){
			$scope.attfile.flow?.upload();
		};

		$scope.activeUpload = function(){
			return true;
		};

		$scope.classOnDrag = function(value){
			if($scope.activeUpload()){
				$scope.dragClass = value;
			}
		};

		$scope.classOffDrag = function(value){
			$scope.dragClass = value;
		};

		$scope.addFlowFile = function($file){
			let file = {
				file_id: '0',
				nrId: $file.uniqueIdentifier,
				file_name: $file.name,
				isFlow: true,
				flowFile: $file,
				done: false
			};
			$scope.attfile.file = file;
		};

		$scope.saveAttachment = function(attachment){
			let data = {
				file_id: attachment.file.file_id,
				title: attachment.file.file_name
			};
			$scope.postElements.attachments.push(data);
			$scope.attfile.file = {};
		};

		$scope.removeAttachment = function(ev, attachment){
			$scope.postElements.attachments = $filter('filter')($scope.postElements.attachments, {file_id: '!'+attachment.file_id}, true);
		};
		
		$scope.isValid = function(){
			 if(!$scope.postElements.decision_date_cet && !$scope.postElements.payment_date_cet){
			 	return false;
			 }
			 
			return true;
		};
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function() {
			if(!$scope.isValid()) {
				return;
			}
			$mdDialog.hide($scope.postElements);
		};
	}
}


